// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2X6HH","sendOtp":"AuthorizeToLogin_sendOtp__Haqoe"};